export interface IDisposable {
  Dispose();
}

export class Disposer {
  private objectList: IDisposable[];

  constructor() {
    this.objectList = [];
  }

  Track(obj: IDisposable) {
    if (obj) this.objectList.push(obj);
  }

  Untrack(key: IDisposable) {
    const index = this.objectList.indexOf(key, 0);
    if (index > -1) {
      this.objectList.splice(index, 1);
    }
  }

  Dispose() {
    for (const obj of this.objectList) {
      if (obj) obj.Dispose();
    }
  }
}
